import { useState } from 'react';
import Reveal from './Reveal';

const CONTRACT = [
  { icon: 'ri-file-shield-2-line', text: '收到线索先做信源初判，再决定是否建档' },
  { icon: 'ri-shield-check-line', text: '投稿人身份与个人信息默认保护，不做公开' },
  { icon: 'ri-time-line', text: '复核有结论后会在专题内标注信源编号' },
];

export default function TipCta() {
  const [text, setText] = useState('');
  const [toast, setToast] = useState<string | null>(null);

  const submit = () => {
    if (!toast) {
      setToast('线索已进入初判队列（本站为演示页面，未接入真实后台）。感谢你的参与。');
      setText('');
      setTimeout(() => setToast(null), 3600);
    }
  };

  return (
    <section id="zhengji" className="scroll-mt-28 border-t-4 border-[#262019] bg-[#262019]">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div>
              <p className="flex items-center gap-2 text-xs font-bold tracking-[0.3em] text-[#e0a01a]">
                <i className="ri-megaphone-fill"></i>CALL FOR TIPS · 线索征集
              </p>
              <h2 className="font-display mt-4 text-3xl font-black leading-tight text-white md:text-5xl">
                你手里有没有
                <br />
                一条「对不上的证据」？
              </h2>
              <p className="mt-5 max-w-lg text-sm leading-7 text-[#cfc4b2]">
                起底与扒皮从来不是一个人能做完的事。如果你见到时间线对不上的口径、前后矛盾的说明，或一张能说明问题的单据，欢迎提交给整理组做交叉核对。
              </p>
              <ul className="mt-7 space-y-3">
                {CONTRACT.map((c) => (
                  <li key={c.text} className="flex items-start gap-3 text-sm text-[#d8cbb6]">
                    <i className={`${c.icon} mt-0.5 text-lg text-[#e0a01a]`}></i>
                    {c.text}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="rounded-lg bg-[#2e261e] p-5 md:p-6">
              <div className="flex items-center justify-between">
                <p className="text-sm font-bold text-white">提交线索材料</p>
                <span className="flex items-center gap-1 rounded-full bg-[#c83424]/20 px-2.5 py-1 text-[11px] font-semibold text-[#f0a08a]">
                  <i className="ri-lock-2-line"></i>隐私保护
                </span>
              </div>

              <label className="mt-4 block text-xs font-semibold text-[#9a8f7c]">
                简要描述你发现的「对不上」之处（限 500 字）
              </label>
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                maxLength={500}
                placeholder="例：某直播间宣传的批次号与包装标注不一致……附上可公开的证据会更利于核对。"
                className="mt-2 h-32 w-full resize-none rounded-md border border-[#4a4037] bg-[#211a13] p-3 text-sm text-[#f0e8d8] outline-none transition placeholder:text-[#6b5f51] focus:border-[#e0a01a]"
              ></textarea>
              <div className="mt-1 text-right text-[11px] text-[#6b5f51]">{text.length}/500</div>

              <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:items-center">
                <button
                  onClick={submit}
                  className="flex flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-[#c83424] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#e04b35]"
                >
                  <i className="ri-send-plane-fill"></i>提交线索
                </button>
                <span className="flex items-center justify-center gap-1.5 rounded-md border border-[#4a4037] px-4 py-3 text-xs text-[#9a8f7c]">
                  <i className="ri-folder-upload-line"></i>可附材料截图（演示）
                </span>
              </div>

              {toast && (
                <p className="mt-3 flex items-start gap-2 rounded-md bg-[#e0a01a]/15 px-3 py-2.5 text-xs leading-5 text-[#f0c68a]">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-[#e0a01a]"></i>
                  {toast}
                </p>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}